const FUSE_OPTIONS = {
	shouldSort: true,
	findAllMatches: true,
	includeScore: false,
	threshold: 0.6,
	location: 0,
	distance: 100,
	maxPatternLength: 32,
	minMatchCharLength: 1,
	keys: ["name"],
};

export default FUSE_OPTIONS;
